function capitalized(name) {
    const capitalizedFirst = name[0].toUpperCase();
    const rest = name.slice(1);
    return capitalizedFirst + rest;
}
function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

function getSeatInfo(ticket, t) {
    const parts = [];
    if (ticket.sector && ticket.sector !== '-' && ticket.sector !== '') {
        parts.push(`${ticket.sector}`);
    }
    /* if (ticket.section && ticket.section !== '-' && ticket.section !== '') {
        parts.push(`${ticket.section}`);
    } */
    if (ticket.row && ticket.row !== '-' && ticket.row !== '') {
        parts.push(`${capitalized(t('row'))} ${ticket.row}`);
    }
    if (ticket.label && ticket.label !== '-' && ticket.label !== '') {
        parts.push(`${capitalized(t('seat'))} ${ticket.label}`);
    }
    return parts.join(', ');
}

function hasSeatInfo(ticket) {
    if (ticket.label != null && ticket.label !== "" && ticket.label !== "-" && ticket.label !== "null") {
      return true;
    }
    return false;
  }

export {capitalized, delay, getSeatInfo, hasSeatInfo}